import { render, staticRenderFns } from "./LeadSettings.vue?vue&type=template&id=4a9902ec&scoped=true"
import script from "./LeadSettings.vue?vue&type=script&lang=js"
export * from "./LeadSettings.vue?vue&type=script&lang=js"
import style0 from "./LeadSettings.vue?vue&type=style&index=0&id=4a9902ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9902ec",
  null
  
)

export default component.exports